import React, { useEffect } from 'react';
import '../css/footer.css';
// import { IoLogoWhatsapp } from 'react-icons/io';
import { SiGithub } from 'react-icons/si';
import { BsLinkedin } from 'react-icons/bs';

function Footer() {
    useEffect(() => {
        const handleScroll = () => {
            const reveals = document.querySelectorAll(".reveal");
            reveals.forEach((reveal) => {
                const windowHeight = window.innerHeight;
                const elementTop = reveal.getBoundingClientRect().top;
                const elementVisible = 150;

                if (elementTop < windowHeight - elementVisible) {
                    reveal.classList.add("revealed");
                } else {
                    reveal.classList.remove("revealed");
                }
            });
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <>
            <footer className="reveal revealed">
                <div id="contact">
                    <div>
                        <p>
                            Let's shake hands{" "}
                            <img src="./images/emoji-handshake.png" width="24" height="24" alt="Handshake emoji" />
                        </p>
                        <a href="#!" style={{ textDecoration: "none", filter: "grayscale(1)" }}>hello@rvkt.io</a>
                    </div>

                    {/* <a
                        href="https://wa.me/8860733786"
                        style={{ fontSize: "15px", color: "#0fe60f", letterSpacing: "2px", textDecoration: "none" }}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Message On WhatsApp <IoLogoWhatsapp style={{ fontSize: "20px" }} />
                    </a> */}

                    <div>
                        {/* <p>
                            Are you interested in a long-term relationship?{" "}
                            <a href="#!" target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none", filter: "grayscale(1)" }}>
                                Download my CV
                            </a>
                        </p> */}
                        <div>
                            <a href="https://github.com/Rvkt" target="_blank" className="social-link" rel="noopener noreferrer" style={{ textDecoration: "none", filter: "grayscale(1)" }}>
                                <SiGithub /> Github
                            </a>&nbsp;&nbsp;&nbsp;
                            <a href="https://www.linkedin.com/in/rvkt/" target="_blank" className='social-link' rel="noopener noreferrer" style={{ textDecoration: "none", filter: "grayscale(1)" }}>
                                <BsLinkedin /> LinkedIn
                            </a>
                        </div>
                    </div>
                    <p>© 2024</p>
                </div>
                {/* <button onClick={onClick}>
                    <img src="./images/icon-power.svg" alt="Power icon" />
                </button> */}
            </footer>
        </>
    )
}

export default Footer